import gql from "graphql-tag";

// shared inquiry shape — used by the list, and by the single-inquiry fetch that
// powers "open the inquiry detail directly" from a journey step / the feed.
const INQUIRY_FIELDS = `
  id
  name
  email
  topic
  message
  phone
  createdAt
  createdAtTime
  lastActivityAt
  manual
  state
  stateChangedAt
  nextActionAt
  nextActionNote
  lostReason
  read
  attended
  waitingDays
  emailStatus
  emailStatusAt
  visitorId
  leadTier
  leadScore
  investmentType
  operationType
  location
  characteristics
  agentConversation {
    id
    status
    agentUnread
    lastMessageAt
    lastMessagePreview
  }
  properties {
    id
    fullAddress
    propertyType
    state
    price
    currency
    sellPrice
    sellCurrency
    operationTypes
    images {
      id
      smallUrl
      thumbUrl
    }
  }
  search {
    id
    state
    createdAt
    resultsCount
    currency
    minBrooms
    maxBrooms
    minRooms
    maxRooms
    minBaths
    maxBaths
    minPrice
    maxPrice
    minCommonExpenses
    maxCommonExpenses
    operationType
    address
    propertyType
    features
    unseenResults
    results {
      id
      score
      seenBy
      state
      property {
        id
        propertyType
        state
        description
        currency
        price
        disabled
        fullAddress
        images {
          id
          name
          size
          url
          thumbUrl
          smallUrl
        }
      }
    }
    user {
      id
      profile {
        name
        email
        address
        phone
      }
    }
  }
  user {
    id
    email
  }
  contact {
    id
  }
  property {
    id
    fullAddress
    propertyType
    state
    price
    currency
    sellPrice
    sellCurrency
    operationTypes
    description
    images {
      id
      smallUrl
      thumbUrl
    }
  }
`;

export const Inquiries = gql`
  query inquiries(
    $page: ID
    $perPage: ID
    $type: String
    $mine: Boolean
    $manual: Boolean
    $ownerId: ID
    $userId: ID
    $propertyId: ID
    $status: [String!]
    $operationType: String
    $search: String
    $order: String
  ) {
    inquiries(
      page: $page
      perPage: $perPage
      type: $type
      mine: $mine
      manual: $manual
      ownerId: $ownerId
      userId: $userId
      propertyId: $propertyId
      status: $status
      operationType: $operationType
      search: $search
      order: $order
    ) {
      pages
      inquiries { ${INQUIRY_FIELDS} }
    }
  }
`;

// One inquiry by id — opens its detail directly (journey step / latest feed).
export const Inquiry = gql`
  query inquiry($id: ID!) {
    inquiry(id: $id) { ${INQUIRY_FIELDS} }
  }
`;

export const Comments = gql`
  query comments($id: ID!) {
    comments(id: $id) {
      id
      text
      createdAt
      visibleToClient
      fromClient
      user {
        id
        email
      }
    }
  }
`;

export const PropertyRecommendations = gql`
  query propertyRecommendations($inquiryId: ID!, $limit: Int) {
    propertyRecommendations(inquiryId: $inquiryId, limit: $limit) {
      id
      propertyType
      state
      price
      currency
      sellPrice
      sellCurrency
      operationTypes
      fullAddress
      images {
        id
        smallUrl
        thumbUrl
      }
    }
  }
`;

// the CRM notification bell: new consultas + client replies, per-staff unseen flag
export const NotificationsFeed = gql`
  query notificationsFeed($limit: Int) {
    notificationsFeed(limit: $limit) {
      id
      kind
      inquiryId
      name
      propertyLabel
      excerpt
      at
      unseen
    }
  }
`;

// just the sidebar "Consultas" badge number (refetched on cable events)
export const UnseenInquiriesCount = gql`
  query agency($id: ID!) {
    agency(id: $id) {
      id
      unseenInquiries
    }
  }
`;

// the funnel board — every inquiry grouped by stage (cards capped per column)
export const InquiryBoard = gql`
  query inquiryBoard($mine: Boolean, $perColumn: Int) {
    inquiryBoard(mine: $mine, perColumn: $perColumn) {
      state
      count
      staleCount
      inquiries {
        id
        name
        state
        read
        manual
        stateChangedAt
        nextActionAt
        nextActionNote
        lostReason
        leadTier
        leadScore
        createdAtTime
        lastActivityAt
        property {
          id
          fullAddress
        }
        properties {
          id
        }
      }
    }
  }
`;
